export default __webpack_public_path__ + "static/media/n12.84f3d423.svg";